/**
 *
 * AdministratorBCView sagas
 *
 */

import {put, takeLatest, call} from 'redux-saga/effects';
// import {push} from "react-router-redux";
import {openViewDialog} from 'containers/AdvancedFormDialog/actions';
import {changeEntitiesState} from "domain/Data/actions";
import * as api from 'utils/api';
import {EXECUTE_VIEW_ACTION, HANDLE_PARAMS_ACTION, TENANT_ANNOUNCEMENT_FORM_DIALOG} from './constants';
import {CLOSE_DIALOG} from 'containers/AdvancedFormDialog/constants';


const goDefaultView = (action) => action.type === CLOSE_DIALOG && action.meta.dialog === TENANT_ANNOUNCEMENT_FORM_DIALOG;

export default function createReceptionViewSaga(config = {}) {
    return function* rootSaga() {
        yield takeLatest(EXECUTE_VIEW_ACTION, (config.executeViewActionSaga || executeViewActionSaga));
        yield takeLatest(HANDLE_PARAMS_ACTION, handleParamsSaga);
        yield takeLatest(goDefaultView, executeGoDefaultViewSaga);
    };
}

function* handleParamsSaga({payload: {id}}) {
    const response = yield call(api.load, 'announcements', id);
    const announcement = response.data;
    if (!announcement) {
        return;
    }
    yield put(changeEntitiesState('announcements', [announcement]));
    yield put(openViewDialog(TENANT_ANNOUNCEMENT_FORM_DIALOG, {id}));
}

function* executeGoDefaultViewSaga() {
    // yield put(push('..'))
}

function* executeViewActionSaga({payload: {id}}) {
    if (id) {
        yield put(openViewDialog(TENANT_ANNOUNCEMENT_FORM_DIALOG, {id}));
    }
}


